<template>
  <div class="block-head-line f-b-c">
    <h3>{{ title }}</h3>
    <a v-if="!hidMoreBtn" :href="moreBtnUrl" class="a-btn" target="_blank">更多 &gt;</a>
  </div>
</template>

<script>
export default {
  name: "BlockHeadLine",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    moreBtnUrl: {
      type: String,
      default: ""
    },
    hidMoreBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.block-head-line{
	border-bottom: 2px solid #eee;
	height: 32px;
	h3{
		font-size: 16px;
		font-weight: bold;
		color: #333;
		position: relative;
		line-height: 30px;
		&:after{
			content: '';
			display: block;
			width: 100%;
			height: 2px;
			background-color: $--color-primary;
			position: absolute;
			left: 0;
			bottom: -2px;
		}
	}
}
</style>
